import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Container, Card, Form, Row, Col, Button} from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { useNavigate } from 'react-router-dom'
import { obtenerExcel } from "../../store/actions/consulta-360-actions";

const DetalleGestion360 = ({listaDetalle, itemSeleccionado}) => {
    
    const history = useNavigate()
    const [loading, setLoading] = useState(false)

    const data_consulta360 = useSelector((state) => state.consulta360Reducer)
    const {excel} = data_consulta360

    const obtenerColumnas = () => {

        return [
            { 
                dataField: 'IdCaso', text: 'ID Caso', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
           
            { 
                dataField: 'EstadoCaso', text: 'Estado', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'Responsable', text: 'Responsable Asignado', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'FechaAsignacion', text: 'Asignación Caso', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'Siniestro', text: 'Siniestro', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'FechaSiniestro', text: 'Fecha Sin.', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'TipoGestion', text: 'Tipo Gestión', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'SituacionSiniestro', text: 'Situación Siniestro', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            }, 
            {
                dataField: 'PatenteAsegurado', text: 'Patente Asegurado', sort: true, headerAlign: 'center', align: 'center'
                ,headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            {
                dataField: 'PatenteTercero', text: 'Patente Tercero', sort: true,  headerAlign: 'center', align: 'center'
                , headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },          
            {
                dataField: 'CiaTercero', text: 'Cia Tercero', sort: true, headerAlign: 'center', align: 'center'
                , headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            }, 
            {
                dataField: 'accion', text: 'Acción' , isDummyField: true,  headerAlign: 'center', align: 'center' ,
                
                formatter: (cell, row) => (
                    <div>
                        <Button type="button" variant="subir me-md-2" size="sm" onClick={ () => onClick(row) }>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                      </svg>
                  </Button>
                    </div>
                )
                , headerStyle:{color:'white', backgroundColor:'#7594C1',verticalAlign: 'middle'}
            }
        ];
    }
    const onClick = (row) => {
        var path = '/detalle-caso';
        history(path, {
            state: {
            row,
            origen:'consulta360'
        }
        })
    };
    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date( date[2], date[1] - 1, date[0]).getTime();
    }

    const dispatch = useDispatch();
    const obtenerExcelBandeja = () => {

        if (listaDetalle && listaDetalle.length > 0) {

             setLoading(true);
                        
            let params = localStorage.getItem('query');      
            const query = Buffer.from(params).toString('base64');      
            dispatch(obtenerExcel(query));
        }
    }
    useEffect(() => {    
        if (excel) {
            setLoading(false);            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }
    }, [excel]);

    const handleReload = () => {

        if (listaDetalle && listaDetalle.length > 0) {

            console.log("TODO: Reload!!");
        }
    }
    return (
        <Fragment>
            <LoadingComponent show={loading}/>
            <Container>
                <Container> 

                <Card >
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}>
                        Detalle de Casos ({listaDetalle?.length}) - {itemSeleccionado?.Concepto} - {itemSeleccionado?.nivelSeleccionado}
                    </Card.Header>
                    <ToolkitProvider search bootstrap4 keyField="Id" 
                        data={ listaDetalle ? listaDetalle : [] } 
                        columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'Id', order: 'asc' }] }>
                        { 
                        props =>                   
                            <div>
                                
                                <Row>
                                    <Col md={4} className="d-grid gap-2 d-md-flex justify-content-md-start mt-2 mb-2">
                                        <Button className="mx-2" type="button" variant="success" size="sm" onClick={() => { obtenerExcelBandeja() }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                                            <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                            </svg>
                                        </Button>
                                    </Col>                           
                                    <Col md={8} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                        
                                        <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                        <Button className="mx-2" type="button" variant="outline-info" size="sm" onClick={() => { handleReload() }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                            </svg>
                                        </Button>
                                    
                                    </Col>                           
                                </Row>                        
                                <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                            </div>
                        }
                    </ToolkitProvider>
                </Card>
                </Container>                 
            </Container>
        </Fragment>
    )

}
export default DetalleGestion360